export default __webpack_public_path__ + "static/appstore-icon-484ba72ba579c7ffd0b311a3a12a3720.png";